var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackbone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80.92 100.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#002a41}.cls-2{fill:#0071b5}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.1.09v54.36l40.46 23.06V61.83L13.49 46.41V22.17L40.56 37.6V23.16L.1.09z",
    transform: "translate(-.1 -.09)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81 .09v54.36L40.56 77.51V61.83l27.06-15.42V22.17L40.56 37.6V23.16L81 .09zM.1 100.6V46.24l40.46-23.06v15.68L13.49 54.29v23l27.07-15.43v15.68L.1 100.6z",
    transform: "translate(-.1 -.09)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81 100.6V46.24L40.56 23.18v15.68l27.06 15.43v23L40.56 61.86v15.68L81 100.6z",
    transform: "translate(-.1 -.09)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackbone);
export default __webpack_public_path__ + "static/media/backbone.7e59b6f7dee4f4bea08bc97afaeb4052.svg";
export { ForwardRef as ReactComponent };